export const fi = {
    "TRIGGER_LISTEN" : "Kuuntelee laukaisuja",
    "ASSIST_EMPTY_MSG" : "Agentti AI kuuntelee keskustelua aktiivisesti ja on valmis auttamaan automaattisesti, kun se aktivoituu.",
    "MYBOT_TRIGGET_LISTEN" : "Ei aktiivisia My Bot -tehtäviä tällä hetkellä",
    "MYBOT_EMTPY_MSG" : "Aloittaaksesi tehtävän My Botissa, siirry hakuvälilehteen ja valitse haluamasi tehtävän kohdasta 'Käynnistä agentin syötteillä'.",
    "PROACTIVE_MODE": "Proaktiivinen tila",
    "SETTINGS": "Asetukset",
    "HELP_AND_SUPPORT": "Ohje ja tuki",
    "HELP": "Apua",
    "LANGUAGE": "Kieli",
    "THEME": "Teema",
    "PLAYBOOK": "Pelikirja",
    "AUTOMATIC": "Automaattinen",
    "DARK": "Tumma",
    "LIGHT": "Vaalea",
    "THEME_DESC": "Tämä käyttää järjestelmän oletustilaa",
    "DOCUMENTATION": "Dokumentaatio",
    "DOC_DESC": "Tutustu syvällisiin dokumentaatioartikkeleihimme.",
    "FAQ_U": "UKK",
    "FAQ_DESC": "Tutustu Agentti AI:n usein kysyttyihin kysymyksiin.",
    "KORE_ACADEMY": "Kore Akatemia",
    "KORE_ACA_DESC": "Opi lisää Agentti AI:sta käymällä akatemian kursseja.",
    "SEARCH": "Haku",
    "MY_BOT": "My Bot",
    "ASSIST": "Auta",
    "TAP_SEARCH":"Napauta hakeaksesi",
    "TRANSCRIPT": "Puhtaaksikirjoitus",
    "HISTORY" : "Historia",
    "STARTOVER" : "Aloita alusta",
    "RESTART_INPUTS" : "Käynnistä uudelleen tallennetuilla syötteillä",
    "ASKCUSTOMER" : "Kysy asiakkaalta",
    "TELLCUSTOMER" : "Kerro asiakkaalle",
    "WELCOME_MSG" : "Tervetuloa viesti",
    "SEND" : "Lähetä",
    "SENT" : "Lähetetty",
    "AWAITING" : "Odotetaan vastausta | Kirjoita jatkaaksesi",
    "OVERRIDE" : "Kirjoita jatkaaksesi",
    "OVERRIDE_FILE" : "Liitä tiedosto jatkaaksesi",
    "ACCEPT_RESPONSE" : "Vastaus hyväksytty",
    "AGENT_ENTERED" : "Agentti saapui",
    "EXPECTED_FORMAT" : "Odotettu muoto", 
    "INPUT_VALUES" : "Syötteen arvot", 
    "RESTART" : "Käynnistä uudelleen",
    "START_OVER" : "Aloita alusta",
    "RESTART_CAPTURE" : "Käynnistä uudelleen tallennetuilla syötteillä",
    "CANCEL" : "Peruuta",
    "INTERRUPT_DIALOG" : "KESKEYTETTY KESKUSTELUTEHTÄVÄ",
    "RUN" : "Suorita",
    "RUN_AGENT" : "Käynnistä agentin syötteillä",
    "STEP" : "Askel",
    "DIALOG_TASK" : "Keskustelutehtävä",
    "FAQ" : "UKK",
    "SNIPPET" : "Vastaukset",
    "ARTICLE" : "Verkkosivut",
    "FILE" : "Tiedostot",
    "SUGGESTED" : "Ehdotettu",
    "ALL_DIALOG" : "Kaikki keskustelutehtävät",
    "DIALOG_TEXT" : "Keskustelu",
    "INTENT_IDENTIFIED" : "Asiakkaan ilmaus",
    "NOT_WHAT_LOOKING" : "Väärä ehdotus?",
    "BOT" : "Botti", 
    "CUSTOMER" : "Asiakas",
    "YOU" : "Sinä",
    "TERMINATE_CONV" : "Päätä keskustelutehtävä",
    "TERMINATE_CONV_DESC" : "Haluatko varmasti päättää keskustelutehtävän? Agentti AI ei enää voi tehdä ehdotuksia.",
    "YES_TERMINATE" : "Kyllä, päätä",
    "NO_CANCEL" : "Ei, peruuta",
    "OVERRIDE_CONTINUE" : "Jatka ohitustilassa",
    "SUMMARY_TEXT" : "Yhteenveto",
    "SUBMIT" : "Lähetä",
    "INTERRUPT_OCCURED" : "Keskeytys tapahtui",
    "IDENTIFIED_INTENT" : "Tunnistettu tarkoitus",
    "INTERRUPT_DESC" : "Tämän suorittaminen päättää käynnissä olevan keskustelutehtävän.",
    "ACCEPT_RUN" : "Hyväksy ja suorita",
    "RUN_LATER" : "Suorita myöhemmin",
    "KNOW_MORE" : "Lue lisää",
    "MORE_TEXT" : "Lisää",
    "LESS_TEXT" : "Vähemmän",
    "VIEW_MORE" : "Näytä lisää",
    "VIEW_LESS" : "Näytä vähemmän",
    "SHOW_MORE_FAQ" : "Näytä lisää UKK:ta",
    "SHOW_LESS_FAQ" : "Näytä vähemmän UKK:ta",
    "SHOW_MORE_ARTICLE" : "Näytä lisää verkkosivuja",
    "SHOW_LESS_ARTICLE" : "Näytä vähemmän verkkosivuja",
    "SHOW_MORE_SNIPPET" : "Näytä lisää vastauksia",
    "SHOW_LESS_SNIPPET" : "Näytä vähemmän vastauksia",
    "SHOW_MORE_FILES" : "Näytä lisää tiedostoja",
    "SHOW_LESS_FILES" : "Näytä vähemmän tiedostoja",
    "VIEW_ALL_DIALOG" : "Näytä kaikki keskustelut",
    "VIEW_FEW_DIALOG" : "Näytä muutama keskustelu",
    "HELP_FULL" : "Hyödyllinen?",
    "THANKYOU" : "Kiitos!",
    "EXPAND_MORE" : "Laajenna / Lisää",
    "CLOSE_TEXT" : "Sulje",
    "STARTED" : "Aloitettu",
    "ENDED" : "Päättynyt",
    "VIEW_FULL_ARTICLE" : "Näytä verkkosivu",
    "VIEW_FULL_FILE" : "Näytä tiedosto",
    "COPIED" : "Kopioitu",
    "SENTI_ANALY" : "Tunneanalyysi",
    "WRONG_SUGGESTION" : "Väärät ehdotukset",
    "INCORRECT_INTENT" : "Väärä tarkoitus",
    "ACCIDENTAL_CLICK" : "Tahaton klikkaus",
    "TIME_TAKING" : "Aikaa vievä",
    "OTHER" : "Muu",
    "PLAYBOOK_EMPTY_MSG" : "Valitse toistokirja",
    "PLAYBOOK_EMPTY_DESC" : "Agentti AI ei pysty lataamaan toistokirjaa, koska kaikki saatavilla olevat toistokirjat ovat dynaamisia. Klikkaa 'Valitse toistokirja' käyttääksesi toistokirjaa.",
    "STAGE" : "Vaihe", 
    "PROCEED_TO_CLOSE" : "Jatka sulkemiseen",
    "RECOMENDED_PLAYBOOK" : "SUOSITELTU TOISTOKIRJA",
    "PRIMARY_SCRIPTS" : "PÄÄKÄSIKIRJOITUKSET",
    "DYNAMIC_SCRIPTS" : "DYNAAMISET KÄSIKIRJOITUKSET",
    "RESUME" : "Jatka",
    "ENABLE_CLOSE" : "Klikkaa 'jatka sulkemiseen' painiketta aktivoidaksesi sulkemisvaiheen",
    "LIST_VIEW" : "Listanäkymä",
    "TERMINATE" : "Lopeta",
    "MINIMIZE" : "Pienennä",
    "MAXIMIZE" : "Suurennus",
    "NO_SEARCH_RESULT" : "Ei hakutuloksia",
    "SENTIMENT_AWAITING" : "Odotetaan tunteita",
    "POSITIVE" : "Pos",
    "NEGATIVE" : "Neg",
    "ASSOCIATED_WORK_NOTES": "Aikaisemmat ratkaisu muistiinpanot",
    "AGENT_JOINED_CONV": "Agentti liittyi keskusteluun",
    "AUTOSCROLL_ASSIST" : "Automaattinen vieritys Assist-välilehden sisällölle",
    "AUTO_SCROLL_TOOLTIP":"Ohjaa Assist-välilehden, Botini ja Transkriptivälilehden sisällön automaattista vieritystä",
    "FILE_SIZE_MSG" : "Tiedoston koon tulee olla enintään 25 MB. Yritä uudelleen.",
    "OVERRIDE_BTN" : "Ohita",
    "FILE_NAME":"Tiedoston nimi",
    "CHOOSE_FILE" : "Valitse tiedosto",
    "SUMMARY_ERROR_TEXT" : "Pahoittelut, mutta tämän keskustelun yhteenvedon tuottamisessa ilmeni ongelma. Luo oma yhteenveto",
    "ASK_A_QUESTION": "Kysy kysymys",
    "COPY" : "Kopioi",
    "TELL_US_MORE": "Kerro meille lisää…",
    "TAB_TEXT":"Ei välilehtiä käytössä! Ota vähintään yksi välilehti käyttöön",
    "THANKS_FEEDBACK": "Kiitos palautteestasi",
    "SOMETHING_WRONG": "Jotain meni pieleen",
    "CLICK_ERROR_DETAILS": "Napsauta nähdäksesi virhetiedot",
    "NO_ACTIVE_PLAYBOOK": "Ei aktiivista toimintasuunnitelmaa",
    "REPHRASE_QUESTION": "Voisitko muotoilla kysymyksesi uudelleen tai kysyä jotain muuta?",
    "INTERNAL_INFO": "Sisäinen tieto",
    "SOURCES": "Lähteet",
    "CONVERSATION_SUMMARY": "Keskustelun yhteenveto",
    "WAITING": "Odottaa",
    "WIDGET_DISABLED": "Widget on pois käytöstä",
    "AI_SETTINGS_DISABLED": "AI-asetukset on poistettu käytöstä! Ole hyvä ja ota yhteyttä AI-ylläpitäjään",
    "SERVER_CONNECTION_ERROR": "Virhe palvelimelle yhdistettäessä",
    "VIEW": "Näytä",
    "ATTACHMENT_INPUT": "Liitteen syöttö",
    "TYPE_SUMMARY": "Kirjoita yhteenveto",
    "VIEW_FULL_ARTICLE_2": "Näytä koko artikkeli",
    "VIEW_FULL_FILE_2": "Näytä koko tiedosto",
    "BY":"Kautta",
    GENERATE_SUMMARY: "Luo yhteenveto",
    PREV_SUMMARIES: "Aiemmin luodut yhteenvedot",
    DIALOG_WORKFLOWS: "Dialogi-työnkulut",
    SHOW_ALL_DIALOG: "Näytä kaikki dialogitehtävät",
    SHOW_ALL_DIALOGS: "Näytä kaikki dialogit",
    CUSTOM_TAB: "Mukautettu välilehti",
    AGENT_INPUT: "Agentin syöte",
    "CUSTOM_EMPTY_MSG" : "Ei aktiivista työnkulua",
    "CUSTOM_TAB_DESC" : "Aloita työnkulku, suorita yksi luettelosta, joka on näkyvissä näytön alareunassa.",
    "SUBMIT_OVERALL_FEEDBACK" : "Lähetä yleiskomento",
    "FEEDBACK_POPUP_SUBTITLE" : "Kommentit widgetin ja sen ominaisuuksien kannalta",
    "FEEDBACK_SATISFIED" : "Tyytyväinen",
    "FEEDBACK_UNSATISFIED" : "Ei tyytyväinen",
    "FEEDBACK_PROVIDE_REASONS" : "Anna lisätietoja…",
    "FEEDBACK_TITLE" : "Kommentti",
    "AGENTIC_THINKING" : "Ajattelee",
    "AGENTIC_AGENT_TITLE" : "Agentti",
    "AGENTIC_COPILOT_MODE_TITLE" : "Agentic Copilot -tila",
    "AGENTIC_SENDING_MESSAGE" : "Lähetetään...",
    "AGENTIC_COPILOT_DESC" : "Agentic Copilot kuuntelee aktiivisesti keskusteluasi ja on valmis auttamaan automaattisesti",
    "AGENTIC_SEARCH_RESULTS" : "Agentti Tulokset"
}